/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { Wealthlane_AwardService_Dtos_TransferAllocate_ReservePoolsResponseDto } from '../models/Wealthlane_AwardService_Dtos_TransferAllocate_ReservePoolsResponseDto';
import type { Wealthlane_AwardService_Dtos_TransferAllocate_TransferStatusUpdateDto } from '../models/Wealthlane_AwardService_Dtos_TransferAllocate_TransferStatusUpdateDto';
import type { Wealthlane_Shared_Hosting_Dtos_GenericApiResponse } from '../models/Wealthlane_Shared_Hosting_Dtos_GenericApiResponse';
import type { Wealthlane_Shared_Hosting_Etos_VinylCallbackEto_VinylCallbackEto } from '../models/Wealthlane_Shared_Hosting_Etos_VinylCallbackEto_VinylCallbackEto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class VinylService {

    /**
     * @param transferAllocateId 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiAwardApiAppVinylDwacIssuance(
transferAllocateId: string,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/vinyl/dwac-issuance/{transferAllocateId}',
            path: {
                'transferAllocateId': transferAllocateId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param ticker 
     * @returns Wealthlane_AwardService_Dtos_TransferAllocate_ReservePoolsResponseDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppVinylReservePoolsByTickerCore(
ticker?: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_TransferAllocate_ReservePoolsResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/vinyl/reserve-pools-by-ticker-core',
            query: {
                'ticker': ticker,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_AwardService_Dtos_TransferAllocate_ReservePoolsResponseDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppVinylExternalReservePools(): CancelablePromise<Wealthlane_AwardService_Dtos_TransferAllocate_ReservePoolsResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/vinyl/external-reserve-pools',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param ticker 
     * @returns Wealthlane_AwardService_Dtos_TransferAllocate_ReservePoolsResponseDto OK
     * @throws ApiError
     */
    public static getApiAwardApiAppVinylExternalReservePoolsByTicker(
ticker?: string,
): CancelablePromise<Wealthlane_AwardService_Dtos_TransferAllocate_ReservePoolsResponseDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/vinyl/external-reserve-pools-by-ticker',
            query: {
                'ticker': ticker,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param identifier 
     * @param requestBody 
     * @returns Wealthlane_Shared_Hosting_Dtos_GenericApiResponse OK
     * @throws ApiError
     */
    public static postApiAwardApiAppVinylCallback(
identifier: string,
requestBody?: Wealthlane_AwardService_Dtos_TransferAllocate_TransferStatusUpdateDto,
): CancelablePromise<Wealthlane_Shared_Hosting_Dtos_GenericApiResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/vinyl/callback/{identifier}',
            path: {
                'identifier': identifier,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param transferAllocateId 
     * @returns string OK
     * @throws ApiError
     */
    public static putApiAwardApiAppVinylIssuanceStatus(
transferAllocateId: string,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/award/api/app/vinyl/issuance-status/{transferAllocateId}',
            path: {
                'transferAllocateId': transferAllocateId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param date 
     * @returns string OK
     * @throws ApiError
     */
    public static getApiAwardApiAppVinylNextBusinessDay(
date?: string,
): CancelablePromise<string> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/award/api/app/vinyl/next-business-day',
            query: {
                'date': date,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns any OK
     * @throws ApiError
     */
    public static postApiAwardApiAppVinylHandleEvent(
requestBody?: Wealthlane_Shared_Hosting_Etos_VinylCallbackEto_VinylCallbackEto,
): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/app/vinyl/handle-event',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
